// A store's order link is order.thisway.co/{slug}. The order site reads the
// slug back through a query string, where "+" turns into a space and "/",
// "?", "#" and "&" break the address, so a slug keeps only lowercase
// letters, numbers and hyphens, up to 30 characters. The API refuses
// anything else (StoreSlug.Refuses); this shapes what is typed so the owner
// never meets that refusal.
export const SLUG_MAX_LENGTH = 30;

export const toSlug = (value) =>
  String(value ?? '')
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .slice(0, SLUG_MAX_LENGTH);
